import { EstimateMapContent, EstimateMapController } from './EstimateMap'

export { default } from './Summary'

export const EstimateSummaryMapConfig = {
  Controller: EstimateMapController,
  Content: EstimateMapContent,
}
